<template>
  <div class="container">
    <div class="modal__content pr100 pl100 pb40">
      <div class="row">
        <div class="col-md-8 col-md-offset-4">
          <h3 class="text-regular mb40 ml20">Edit {{user.name}} {{user.surname}}</h3>
        </div>
      </div>

      <div class="row flex--align-vertical">
        <div class="col-md-4 mb20 pr45">
          <label for="user-profile-image">
            <img :src="'/serve/s/' + user.avatarKey + '?w=240&h=240'" class="img-circle mr15" alt="user.name"
                 v-if="user.avatarKey">
            <img src="/static/images/user/user-avatar-demo-big@2x.png" class="img-circle mr15" alt="user.name" v-else>
          </label>

          <input type="file" id="user-profile-image" accept="image/*" @change="onUserAvatarUpload($event)" hidden>
        </div>

        <div class="col-md-8">
          <div class="form-group">
            <div class="col-md-6 form-row">
              <input class="form-control" type="text" id="name" v-model="user.name" placeholder="First name">
            </div>

            <div class="col-md-6 form-row">
              <input class="form-control" type="text" id="surname" v-model="user.surname" placeholder="Last name">
            </div>

            <div class="col-md-6 form-row">
              <input class="form-control" type="text" id="email" v-model="user.email" placeholder="Email">
            </div>

            <div class="col-md-6 form-row form-row--select" v-if="user.role !== 'admin' && user.role !== 'customer'">
              <select name="user-role" id="user-role" v-model="user.role" class="form-control">
                <option v-for="option in userRoles" :value="option.value">{{option.name}}</option>
              </select>
            </div>

            <div class="col-md-5 form-row">
              <div class="form-row__rate">
                <label for="hour-rate">$</label>
                <input class="form-control" type="number" id="hour-rate" v-model="user.hourRate">
                <label for="hour-rate">per hour</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt20">
        <div class="col-md-8 col-md-offset-4">
          <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">Cancel</button>
          <button class="btn btn--wide" @click="onConfirm">Update</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiUploadUserAvatar } from '@/api/user.api'
  import { errorMessage } from 'modules/Error'
  
  export default {
    data () {
      return {
        user: {
          name: null,
          surname: null,
          email: null,
          hourRate: null,
          role: 'designer',
          avatarKey: null
        },
        userRoles: [
          {
            name: 'Designer',
            value: 'designer'
          },
          {
            name: 'Project Manager',
            value: 'projectManager'
          }
        ]
      }
    },

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    created () {
      this.init()
    },

    methods: {
      init () {
        this.user = _.cloneDeep(this.args)
      },

      async onUserAvatarUpload (e) {
        const param = new FormData()
        param.append('file', e.target.files[0])

        const [err, data] = await apiUploadUserAvatar(param)
        if (err) return errorMessage(err, 'Unable to upload user avatar!')

        return (this.user.avatarKey = data.key)
      },

      onConfirm () {
        this.$bus.$emit('userUpdate', this.user)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateUserModal.vue?1ff026bc